import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { BaseTabuRequestProps } from "../TabuRequest/BaseTabuRequestForm";
import { extractPropInfo } from "../MyDLD/PropertyDetails";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import ComplainantDetails, { ComplainantDetailsState } from "@my-dld/components/RVS/ComplainantDetails";
import DefendantDetails, { DefendantDetailsState } from "@my-dld/components/RVS/DefendantDetails";
import ProjectUnitDetails from "@my-dld/components/RVS/ProjectUnitDetails";
import DocumentDetails, { DocumentDetailsState } from "@my-dld/components/RVS/DocumentDetails";
import { getLocalValue, LocaleValue } from "@eres/core/dist/LocaleValue";
import * as SSO from "@10x/sso";
import { getParticipantID } from "@10x/sso";
import { isEmptyStringOrNull, normaliseMobileNumber } from "@eres/core/dist/StringUtils";
import MessageActionButtonPopup from "@my-dld/components/Popup/MessageActionButtonPopup";
import { replaceNavigate } from "@my-dld/utils/StoreUtils";
import { JQModal } from "@my-dld/components/Popup/Utils";
import {
	ChannelId,
	Complain,
	DocumentDetail,
	Documents,
	DocumentState,
	DocumentTypeId,
	MollakDefendant,
	MollakManagementCompany,
	Notifier,
	NotifierTypeId,
	Participant,
	RemoteDoc,
	RVSCompany,
	RVSLookUp,
	ServiceId,
	ServicesStatus,
	SSORoleId,
	Transaction,
	TransactionService,
	TransactionStatusId
} from "@eres/rvsapi/entities";
import ComplainCategory, { ComplainCategoryState } from "@my-dld/components/RVS/ComplainCategory";
import { LocaleUtil } from "@eres/core";
import { RVSLookUpName, rvsLookUpToStateKey } from "@eres/rvsapi/api";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { RVSApi } from "@eres/rvsapi";
import MollakCompaniesPopup from "@my-dld/components/RVS/MollakCompaniesPopup";
import { getUnitNumber } from "@my-dld/utils/PropertyUtils";
import ComplainDescription from "@my-dld/components/RVS/ComplainDescription";
import RVSSuccessPopup from "@my-dld/components/RVS/RVSSuccessPopup";
import { Redirect } from "react-router";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import PageContent from "@my-dld/components/PageContent";

interface IRVSTrack {
	id: string;
	name: LocaleValue;
}

const RVSTrack: IRVSTrack[] = [
	{
		id: "ComplainantDetails",
		name: LVStrings.complainant_details,
	},
	{
		id: "ComplainCategory",
		name: LVStrings.complain_category,
	},
	{
		id: "DefendantDetails",
		name: LVStrings.defendant_details,
	},
	{
		id: "ProjectUnitDetails",
		name: LVStrings.project_or_unit_details,
	},
	{
		id: "DocumentDetails",
		name: LVStrings.documents,
	},
	{
		id: "ComplainDescription",
		name: LVStrings.complain_desc,
	}
];

interface Props extends RoutedViewProps {

}

interface State {
	property: AssetCard;
	current: IRVSTrack;
	showContactVal?: boolean;
	claimantTypes: RVSLookUp[];
	complainTypes: RVSLookUp[];
	complainCategories: RVSLookUp[];
	defendantTypes: RVSLookUp[];
	showMollakCompanies?: boolean;
	mollakCompanies: RVSCompany[];
	mollakDefendant?: MollakDefendant;
	complainTypeID?: number;
	transactionNo?: string;
}

const LookUpNames = [ RVSLookUpName.CLAIMANT_TYPES, RVSLookUpName.DEFENDANT_TYPES, RVSLookUpName.COMPLAIN_TYPES ];

class RegisterRVSComplaint extends Component<Props, State> {
	private static OWNER_ASSOCIATION_COMPANY = 21;
	complainantDetailsRef!: ComplainantDetails | null;
	complainCategoryRef!: ComplainCategory | null;
	defendantDetailsRef!: DefendantDetails | null;
	projectUnitDetailsRef!: ProjectUnitDetails | null;
	documentDetailsRef!: DocumentDetails | null;
	complainDescRef!: ComplainDescription | null;

	constructor( props: BaseTabuRequestProps ) {
		super( props );
		let property = props.location.state ? props.location.state.property : undefined;
		this.state = {
			property: property,
			current: RVSTrack[ 0 ],
			claimantTypes: [],
			complainTypes: [],
			complainCategories: [],
			defendantTypes: [],
			mollakCompanies: [],
		};
	}

	private static getParticipants( company: RVSCompany ): Participant[] {
		const participant: Participant = {
			ParticipantTypeId: company.ParticipantTypeId,
			ParticipantId: company.ParticipantId,
			ParticipantNumber: company.ParticipantNumber,
			NameAr: company.NameAr,
			NameEn: company.NameEn,
			Email: company.Email,
			Mobile: company.Mobile,
			ContactPersonNameAr: company.ContactPersonNameAr,
			ContactPersonNameEn: company.ContactPersonNameEn,
			ContactPersonEmail: company.ContactPersonEmail,
			ContactPersonMobile: company.ContactPersonMobile,
			ParticipantObject: JSON.stringify( company ),
			Isprimary: true,
			IsActive: true,
		};
		return [ participant ];
	}

	private static getTransactionService( description: string ): TransactionService {
		return {
			TransactionStatusId: TransactionStatusId.Submit,
			ServiceId: ServiceId.OnlineComplain,
			TransactionDescription: description,
			ChannelId: ChannelId.DLDWebsite,
		};
	}

	private static getNotifiers( complainant: ComplainantDetailsState, defendant: DefendantDetailsState ): Notifier[] {
		const company = defendant.company;
		const profileName = SSO.getName();
		let dMobile = normaliseMobileNumber( defendant.defendantMobile! );
		const complainantNotifier: Notifier = {
			NotifierNameAr: profileName ? profileName!.ar! : "",
			NotifierNameEn: profileName ? profileName!.en! : "",
			NotifierEmail: complainant.complainerEmail!,
			NotifierMobile: complainant.complainerMobile!,
			NotifierTypeId: NotifierTypeId.Complainant,
			IsActive: true,
		};
		const defendantNotifier: Notifier = {
			NotifierNameAr: company!.NameAr,
			NotifierNameEn: company!.NameEn,
			NotifierEmail: defendant.defendantEmail ? defendant.defendantEmail : "",
			NotifierMobile: dMobile ? dMobile : "",
			NotifierTypeId: NotifierTypeId.Defendant,
			IsActive: true,
		};
		return [ complainantNotifier, defendantNotifier ];
	}

	private static isClaimantDefendantDetailsValid( complainant: ComplainantDetailsState, defendant: DefendantDetailsState ) {
		let isValid = true;
		if ( defendant.defendantMobile && !isEmptyStringOrNull( defendant.defendantMobile ) ) {
			const cMobile = normaliseMobileNumber( complainant.complainerMobile! );
			const dMobile = normaliseMobileNumber( defendant.defendantMobile! );
			if ( cMobile === dMobile ) {
				isValid = false;
			}
		}
		if ( defendant.defendantEmail && !isEmptyStringOrNull( defendant.defendantEmail ) ) {
			if ( complainant.complainerEmail!.toLowerCase() === defendant.defendantEmail!.toLowerCase() ) {
				isValid = false;
			}
		}
		return isValid;
	}

	componentDidMount() {
		let mobile = SSO.getMobileNumber();
		mobile = mobile ? normaliseMobileNumber( mobile ) : "";
		const email = SSO.getEmail();
		const name = SSO.getName();
		if ( !isEmptyStringOrNull( mobile ) && !isEmptyStringOrNull( email ) && name ) {
			showLoading();
			this.loadLookUps( 0 );
		} else {
			trackEventWithData( "RVS", "OwnerContactDetailsNotValid",
				{ participantId: "" + getParticipantID() } );
			this.setState( { showContactVal: true } );
		}
	}

	render() {
		const {
			property, current, showContactVal, claimantTypes, complainTypes, complainCategories, defendantTypes,
			showMollakCompanies, mollakCompanies, mollakDefendant, complainTypeID, transactionNo
		} = this.state;
		if ( property == null )
			return <Redirect to={ "/mydld" }/>;
		const defendantDetails = ( mollakDefendant && mollakDefendant.company ) ? mollakDefendant : undefined;
		const { val, lbl } = extractPropInfo( property );
		return <React.Fragment>
			<PageContent
				title={ `${ Strings.register_a_complaint } - ${ lbl } : ${ val }` }
				hideQLinks={ true }>
				<PageTitle title={ Strings.register_a_complaint } paths={ [ DashboardBCItem ] }/>
				<div className="row">
					<div className="col-md-8">
						<div className="tender-registration-form">
							<ComplainantDetails
								ref={ r => this.complainantDetailsRef = r }
								claimantTypes={ claimantTypes }/>
							<ComplainCategory
								ref={ r => this.complainCategoryRef = r }
								complainTypes={ complainTypes }
								complainCategories={ complainCategories }
								onComplainTypeChange={ this.onComplainTypeChange }/>
							<DefendantDetails
								ref={ r => this.defendantDetailsRef = r }
								defendantTypes={ defendantTypes }
								mollakDefendant={ defendantDetails }
								complainTypeID={ complainTypeID }/>
							<ProjectUnitDetails
								ref={ r => this.projectUnitDetailsRef = r }
								isMandatory={ complainTypeID === RegisterRVSComplaint.OWNER_ASSOCIATION_COMPANY }
								projectName={ LocaleUtil.getLocalValue( property.project.name, "en" ) }/>
							<DocumentDetails ref={ r => this.documentDetailsRef = r }/>
							<ComplainDescription ref={ r => this.complainDescRef = r }/>
						</div>
						<div className="form-group">
							<button
								className="btn btn_1 btn_style1"
								onClick={ this.onSubmit }>{ Strings.submit_label }</button>
							<button
								className="btn btn-grey btn_style1 ms-2 me-2"
								onClick={ this.onReset }>{ Strings.reset }</button>
						</div>
					</div>
					<div className="col-md-4 side-panel">
						<ul className="list-group" id="TR-list-tab" role="tablist">
							<li className="list-group-item disabled">{ Strings.register_a_complaint }</li>
							{ RVSTrack.map( ( item: IRVSTrack, index: number ) => {
								const active = ( current.id === item.id ) ? "active" : "";
								return <li
									key={ item.id }
									className={ "list-group-item list-group-item-action " + active }
									onClick={ () => this.onItemLick( item ) }>
									<a
										data-bs-toggle="list" role="tab" className={ active }
										style={ { cursor: "pointer" } }>{ ( index + 1 ) + " - " + LocaleUtil.getLocalValue( item.name ) }</a>
								</li>;
							} ) }
						</ul>
					</div>
				</div>
			</PageContent>
			{ showContactVal && <MessageActionButtonPopup
				actionLabel={ Strings.proceed }
				message={ Strings.rvs_contact_details_validation }
				onCancel={ this.onContactValCancel }
				onAction={ this.onContactValProceed }/> }
			{ showMollakCompanies && <MollakCompaniesPopup
				companies={ mollakCompanies }
				onClose={ this.onCompaniesPopupClose }
				onCompanySelect={ this.onCompanySelect }
				complainTypeID={ complainTypeID }/> }
			{ transactionNo && <RVSSuccessPopup
				transactionNo={ transactionNo }
				onDismiss={ this.onSuccessClose }/> }
		</React.Fragment>;
	}

	private onItemLick( item: IRVSTrack ) {
		this.setState( { current: item }, () => {
			const container = document.getElementById( item.id );
			if ( container )
				window.scrollTo( 0, container.offsetTop );
		} );
	};

	private onContactValCancel = () => {
		JQModal( "message_action" ).hide();
		this.setState( { showContactVal: false }, () => {
			this.props.history.goBack();
		} );
	};

	private onContactValProceed = () => {
		JQModal( "message_action" ).hide();
		this.setState( { showContactVal: false }, () => {
			replaceNavigate( "/mydld/profile/view" );
		} );
	};

	private loadLookUps( index: number ) {
		if ( index < LookUpNames.length ) {
			const lookUpName = LookUpNames[ index ];
			RVSApi.loadLookUp( lookUpName ).then( ( resp: any ) => {
				const stateKey = rvsLookUpToStateKey( lookUpName );
				this.setState( {
					...this.state,
					[ stateKey ]: ( resp && resp.Lookups ) ? resp.Lookups : [],
				}, () => {
					this.loadLookUps( index + 1 );
				} );
			} ).catch( reason => {
				this.loadLookUps( index + 1 );
			} );
		} else {
			hideLoading();
		}
	}

	private loadComplainCategoriesByType( type: RVSLookUp ) {
		showLoading();
		RVSApi.loadComplainCategoriesByType( type.ID ).then( ( resp: any ) => {
			this.setState( {
				complainCategories: ( resp && resp.Lookups ) ? resp.Lookups : []
			}, () => this.loadMollakCompany( type.ID ) );
		} ).catch( reason => {
			this.setState( {
				complainCategories: []
			}, () => this.loadMollakCompany( type.ID ) );
		} );
	}

	private loadMollakCompany( typeId: number ) {
		if ( typeId === RegisterRVSComplaint.OWNER_ASSOCIATION_COMPANY ) {
			RVSApi.loadMollakManagementCompany( this.state.property.tabuPropertyId ).then( ( resp: any ) => {
				if ( resp && resp.response && resp.response.items && resp.response.items.length > 0 ) {
					const mollkCompany: MollakManagementCompany = resp.response.items[ 0 ];
					this.loadCompanyByLicenseNumber( mollkCompany );
				} else {
					hideLoading();
				}
			} ).catch( reason => {
				hideLoading();
			} );
		} else {
			hideLoading();
		}
	}

	private loadCompanyByLicenseNumber( mollkCompany: MollakManagementCompany ) {
		RVSApi.loadCompaniesByLicenseNo( mollkCompany.licenseNumber ).then( ( resp: any ) => {
			const results: RVSCompany[] = resp ? resp.AuthorityList : [];
			if ( results.length > 0 ) {
				const defendantDetails: MollakDefendant = {
					mobile: mollkCompany.mobile,
					email: mollkCompany.email,
				};
				if ( results.length > 1 ) {
					this.setState( {
						showMollakCompanies: true,
						mollakCompanies: results,
						mollakDefendant: defendantDetails,
					} );
				} else {
					this.setState( {
						mollakDefendant: { ...defendantDetails, company: results[ 0 ] }
					} );
				}
			}
			hideLoading();
		} ).catch( reason => {
			hideLoading();
		} );
	}

	private onCompaniesPopupClose = () => {
		JQModal( "mollak_companies_popup" ).hide();
		this.setState( {
			showMollakCompanies: false,
		} );
	};

	private onCompanySelect = ( company: RVSCompany ) => {
		JQModal( "mollak_companies_popup" ).hide();
		this.setState( {
			showMollakCompanies: false,
			mollakDefendant: { ...this.state.mollakDefendant, company: company },
		} );
	};

	private onSubmit = () => {
		const infoPromises: Promise<any>[] = [];
		infoPromises.push( this.complainantDetailsRef!.isValid() );
		infoPromises.push( this.complainCategoryRef!.isValid() );
		infoPromises.push( this.defendantDetailsRef!.isValid() );
		infoPromises.push( this.projectUnitDetailsRef!.isValid() );
		infoPromises.push( this.documentDetailsRef!.isValid() );
		infoPromises.push( this.complainDescRef!.isValid() );
		Promise.all( infoPromises ).then( promises => {
			this.buildRequest( promises );
		} ).catch( reason => {

		} );
	};

	private onComplainTypeChange = ( type?: RVSLookUp ) => {
		this.setState( {
			complainCategories: [],
			mollakDefendant: undefined,
			complainTypeID: type ? type.ID : undefined,
		}, () => {
			if ( type )
				this.loadComplainCategoriesByType( type );
		} );
	};

	private buildRequest( promises: any[] ) {
		const complainant: ComplainantDetailsState = promises[ 0 ];
		const complain: ComplainCategoryState = promises[ 1 ];
		const defendant: DefendantDetailsState = promises[ 2 ];
		const projectName: string = promises[ 3 ];
		const docState: DocumentDetailsState = promises[ 4 ];
		const description: string = promises[ 5 ];
		if ( RegisterRVSComplaint.isClaimantDefendantDetailsValid( complainant, defendant ) ) {
			showLoading();
			RVSApi.uploadDocs( docState.docs ).then( ( docs: RemoteDoc[] ) => {
				const transaction: Transaction = {
					Complain: this.getComplain( complainant, complain, defendant, projectName ),
					Participants: RegisterRVSComplaint.getParticipants( defendant.company! ),
					TransactionService: RegisterRVSComplaint.getTransactionService( description ),
					Notifiers: RegisterRVSComplaint.getNotifiers( complainant, defendant ),
					Documents: this.getDocuments( docs ),
					SsoRoleId: SSORoleId.OnlineUser,
					ServicesStatus: ServicesStatus.IssueService,
				};
				this.saveTransaction( transaction );
			} ).catch( ( reason ) => {
				trackEventWithData( "RVS", "DocumentUploadFailed",
					{ participantId: "" + getParticipantID(), reason: reason.toString() } );
				hideLoading();
				showMessage( reason );
			} );
		} else {
			showMessage( Strings.claimant_defendant_detail_val );
		}
	}

	private saveTransaction( transaction: Transaction ) {
		RVSApi.saveTransaction( transaction ).then( ( response: any ) => {
			const transactionNo = response.TransactionNumber;
			trackEventWithData( "RVS", "TransactionSuccess",
				{ participantId: "" + getParticipantID(), transactionNo: transactionNo } );
			hideLoading();
			this.setState( {
				transactionNo: transactionNo,
			} );
		} ).catch( reason => {
			trackEventWithData( "RVS", "TransactionFailed",
				{ participantId: "" + getParticipantID(), reason: reason.toString() } );
			hideLoading();
			showMessage( reason );
		} );
	}

	private getComplain( complainant: ComplainantDetailsState, complain: ComplainCategoryState,
	                     defendant: DefendantDetailsState, projectName: string ): Complain {
		const { property } = this.state;
		return {
			ServiceId: ServiceId.OnlineComplain,
			ComplainCategoryId: complain.complainCategory!.ID,
			ComplainantTypeId: complainant.claimantType!.ID,
			DefendantTypeId: defendant.defendantType!.ID,
			ActivityId: complain.complainType!.ID,
			AuthorityParticipantId: defendant.company!.ParticipantId,
			ProjectName: projectName,
			PlotNumber: property.landNo ? property.landNo : undefined,
			UnitNumber: property ? getUnitNumber( property ) : undefined,
			PropertyType: property.propertyType ? getLocalValue( property.propertyType, "en" ) : undefined,
			Community: property.area ? getLocalValue( property.area, "en" ) : undefined,
		};
	}

	private getDocuments( docs: RemoteDoc[] ): Documents[] {
		const documentDetails: DocumentDetail[] = [];
		docs.forEach( ( doc: RemoteDoc ) => {
			const detail: DocumentDetail = {
				DocumentName: doc.DocumentName,
				DocumentPath: doc.DocumentGuid,
				DocumentStates: DocumentState.Uploaded,
				DocumentTypeId: DocumentTypeId.Documents,
			};
			documentDetails.push( detail );
		} );
		const documents: Documents = {
			DocumentTypeServiceId: ServiceId.OnlineComplain,
			DocumentTypeId: DocumentTypeId.Documents,
			ServiceId: ServiceId.OnlineComplain,
			DocumentDetails: documentDetails,
		};
		return [ documents ];
	}

	private onReset = () => {
		this.complainCategoryRef!.reset();
		this.defendantDetailsRef!.reset();
		this.projectUnitDetailsRef!.reset();
		this.documentDetailsRef!.reset();
		this.complainDescRef!.reset();
	};

	private onSuccessClose = () => {
		this.props.history.goBack();
	};
}

export default RegisterRVSComplaint;
